document.addEventListener("DOMContentLoaded", function () {
function handlize(str) {
    return str
        .toLowerCase() // Chuyển thành chữ thường
        .replace(/[^a-z0-9\s]/g, ' ') // Thay thế các ký tự không phải chữ, số, khoảng trắng bằng khoảng trắng
        .replace(/\s+/g, '-') // Thay khoảng trắng bằng dấu gạch ngang
        .replace(/-+/g, '-') // Loại bỏ các dấu gạch ngang liên tiếp
        .replace(/^-|-$/g, '') // Loại bỏ dấu gạch ngang ở đầu và cuối
        .trim(); // Xóa khoảng trắng thừa
}

  let variantElementsParent = document.querySelector("ul:has(li).ecom-product-single__picker-radio-list");
  if (variantElementsParent) {
    let productForm = variantElementsParent.closest('form[action="/cart/add"]');
    let productId = productForm.dataset.product_id;
    let wpdJson = document.querySelector(`[id^=product-json-${productId}]`);

    let parsedWpdJson = JSON.parse(wpdJson.textContent);
    let variantElements = variantElementsParent.querySelectorAll("li");

    variantElements.forEach((variant, index) => {
      let variantValue = variant.dataset.value;
      let wpdVariants = parsedWpdJson.variants;
      //console.log('handlize(variantValue)', variantValue, handlize(variantValue), wpdVariants[index].title.trim().toLocaleLowerCase(), handlize(variantValue) == wpdVariants[index].title.trim().toLocaleLowerCase());
      
      if (handlize(variantValue) == wpdVariants[index].title.trim().toLocaleLowerCase()) {
        variant.innerHTML += false
          ? `<s class="wpd-ext-compare-at-price" style="text-decoration: line-through;">${EComposer.formatMoney(
              wpdVariants[index].compare_at_price
            )}</s><span>${EComposer.formatMoney(wpdVariants[index].price)}</span>`
          : `<span>${EComposer.formatMoney(wpdVariants[index].price)}</span>`;
      }
      variant.style = "flex-direction: column !important;";
    });
  }
});
